/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentEventTypeEnum } from '../../models/content-event-type-enum';
import { GetEventAuditEvidenceListResponse } from '../../models/get-event-audit-evidence-list-response';

export interface GetEventAuditList$Params {

/**
 * dátum udalosti od
 */
  eventDateFrom?: string;

/**
 * dátum udalosti do
 */
  eventDateTo?: string;
  eventType?: ContentEventTypeEnum;

/**
 * názov obsahu
 */
  content?: string;

/**
 * email používateľa
 */
  userEmail?: string;

/**
 * názov spoločnosti
 */
  company?: string;

/**
 * rola
 */
  role?: string;

/**
 * Číslo stránky
 */
  page?: number;

/**
 * Počet záznamov na stránku
 */
  size?: number;

/**
 * Zoznam atribútov pre zoraďovanie v tvare **column,column**
 */
  sort?: string;

/**
 * Smer zoraďovania atribútov
 */
  direction?: 'ASC' | 'DESC';
}

export function getEventAuditList(http: HttpClient, rootUrl: string, params?: GetEventAuditList$Params, context?: HttpContext): Observable<StrictHttpResponse<GetEventAuditEvidenceListResponse>> {
  const rb = new RequestBuilder(rootUrl, getEventAuditList.PATH, 'get');
  if (params) {
    rb.query('eventDateFrom', params.eventDateFrom, {});
    rb.query('eventDateTo', params.eventDateTo, {});
    rb.query('eventType', params.eventType, {});
    rb.query('content', params.content, {});
    rb.query('userEmail', params.userEmail, {});
    rb.query('company', params.company, {});
    rb.query('role', params.role, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('direction', params.direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetEventAuditEvidenceListResponse>;
    })
  );
}

getEventAuditList.PATH = '/admin/eventAuditEvidence';
